import { render } from "./Individuation.vue?vue&type=template&id=8c0bd9d4"
import script from "./Individuation.vue?vue&type=script&lang=js"
export * from "./Individuation.vue?vue&type=script&lang=js"

import "./Individuation.vue?vue&type=style&index=0&id=8c0bd9d4&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__